// The house loading spinner — one size, one look, so consecutive loading
// faces (the quote flow's, the form renderer's) read as one continuous
// wait instead of a parade of different loaders.

export default function Spinner({ className = "" }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={`inline-block h-12 w-12 animate-spin rounded-full border-[3px] border-oat-200 border-t-evergreen ${className}`}
    />
  );
}
